/*
 * Lib Module DragDrop
 */

Lib.DragDrop = (function () {
    var self = {};

    $(Lib).on('document.ready', function () {
        self.bindDragDrops($("div[data-dragsource]"));
    });

    /**
     * Bind the drag and drop to the dragsources
     * @param dragSources
     */
    self.bindDragDrops = function (dragSources) {

        // Check if we have any sources
        if (dragSources.length) {

            // Loop through each
            dragSources.each(function () {

                // Scope var
                var dragSource = $(this);

                // Get options or default
                var dragOptions = dragSource.data('dragoptions') || {};

                // Extend default options with data attribute provided options
                var options = $.extend({
                    direction: 'vertical',
                    copy: false,
                    copySortSource: false,
                    revertOnSpill: false,
                    removeOnSpill: false,
                    mirrorContainer: document.body,
                    ignoreInputTextSelection: true
                }, dragOptions);

                // Get the target
                var dragTarget = $("div[data-dragtarget='" + dragSource.data('dragsource') + "']");

                //
                if ('disableSourceToSource' in dragOptions && dragOptions.disableSourceToSource) {
                    options.accepts = function (el, target, source) {
                        return !('dragsource' in $(source).data() && 'dragsource' in $(target).data())
                    };
                }

                // Initialize
                var drake = dragula([dragSource.get(0), dragTarget.get(0)], options);

                dragSource.data('dragulaInstance', drake);

            });
        }
    };

    return self;

})();
